// Pages
import Blank from './desktop/pages/Pages/Blank';
import Parties from './desktop/pages/Parties/Parties';
import Trips from './desktop/pages/Trips/Trips';
import Payments from './desktop/pages/Payments/Payments';
import Suppliers from './desktop/pages/Suppliers/Suppliers';
import Drivers from './desktop/pages/Drivers/Drivers';
import Vehicle from './desktop/pages/Vehicles/Vehicles';
import Profile from './desktop/pages/Profile/profile';
import Account from './desktop/pages/Profile/Account';
import UserManagement from './desktop/pages/Profile/UserManagement';
import SubscriptionStatus from './desktop/pages/Payments/SubscriptionStatus';
import Reports from './desktop/pages/Reports/ReportsHome';
import OnlinePayments from './desktop/pages/OnlinePayments/OnlinePayments';
import Invoice from './desktop/pages/Invoices/Invoice';
import DieselCard from './desktop/pages/DieselCard/DieselCard';
import Expenses from './desktop/pages/Expenses/Expenses';
import PaymentPageNew from './desktop/pages/Payments/PaymentPageNew';
import Shops from './desktop/pages/Shops/Shops';
import Fastag from './desktop/pages/Fastag/Fastag';
//Sub Menues
import AddTrip from './desktop/pages/Trips/AddTrip';
import ViewTrip from './desktop/pages/Trips/ViewTrip/ViewTrip';
import ViewParty from './desktop/pages/Parties/ViewParty/ViewParty';
import SingleDriver from './desktop/pages/Drivers/SingleDriver';
import SingleVehicle from './desktop/pages/Vehicle/SingleVehicleComponent';
import ViewSupplier from './desktop/pages/Suppliers/ViewSupplier';
import MapComponent from './desktop/components/MapComponent/MapComponent';
import ViewShop from './desktop/pages/Shops/ViewShop';
import SingleInvoice from './desktop/pages/Invoices/SingleInvoice';
import ViewJourney from './desktop/pages/Trips/ViewJourney/ViewJourney';

import SingleDieselCard from './desktop/pages/DieselCard/SingleDieselCard/SingleDieselCard';

import ViewFastagTruck from './desktop/pages/Fastag/ViewFastagTruck';
//Tabs
import TripsTab from './desktop/pages/Parties/Tabs/TripsTab';
import PaymentsTab from './desktop/pages/Parties/Tabs/PaymentsTab';
import MonthlyBalancesTab from './desktop/pages/Parties/Tabs/MonthlyBalancesTab';
import PartyProfileTab from './desktop/pages/Parties/Tabs/PartyProfileTab'
import TripsTabSupplier from './desktop/pages/Suppliers/Tabs/TripTabsSupplier';
import PassBookTabSupplier from './desktop/pages/Suppliers/Tabs/PassBookTabSupplier';

// Icons
import DashboardRoundedIcon from '@material-ui/icons/DashboardRounded';
import PinDropIcon from '@material-ui/icons/PinDrop';
import AssignmentRoundedIcon from '@material-ui/icons/AssignmentRounded';
import AccountCircleRoundedIcon from '@material-ui/icons/AccountCircleRounded';
import LocalShippingRoundedIcon from '@material-ui/icons/LocalShippingRounded';
import { SteeringWheel,ExpensesIconDweb, ReportsMenu, AccountsMenu, TransactionMenu, PremiumMenuIcon, ReportsIconDweb, FastagIconDweb, OnlinePaymentIcon, InvoicesIcon, ShopKhataIcon, DieselCardIcon } from './components/icons';

//store
import configureStore from './store/configureStore';

const store = configureStore();
const state = store.getState();
let userInfo = JSON.parse(localStorage.getItem('USER_INFO'));

export const getRoutesList = (role, onlinePaymentConfig, fuelCardConfig) => {
  const routes = {
    items: [
      {
        path: '/',
        name: 'Dashboard',
        visible: false,
        type: 'link',
        state: {
          id: 1,
          pageTitle: 'Dashboard'
        },
        icon: DashboardRoundedIcon,
        component: Blank
      },
      {
        path: '/parties',
        name: 'Parties',
        visible: true,
        type: 'submenu',
        state: {
          id: 1,
          pageTitle: 'Parties'
        },
        children: [
          {
            path: '/single-party',
            name: 'View',
            tabs: [
              {
                path: '/trips/:id',
                name: 'Trips',
                type: 'tab',
                component: TripsTab,
                state: {
                  id: 1,
                  tabTitle: 'Trips'
                }
              },
              {
                path: '/passbook/:id',
                name: 'Payments',
                type: 'tab',
                component: PaymentsTab,
                state: {
                  id: 1,
                  tabTitle: 'Passbook'
                }
              },
              {
                path: '/monthly-balances/:id',
                name: 'Monthly Balances',
                type: 'tab',
                component: MonthlyBalancesTab,
                state: {
                  id: 1,
                  tabTitle: 'MonthlyBalancesTab'
                }
              },
              {
                path: '/party-profile/:id',
                name: 'Party Details',
                type: 'tab',
                component: PartyProfileTab,
                state: {
                  id: 1,
                  tabTitle: 'PartyProfileTab'
                }
              }
            ],
            state: {
              id: 1,
              pageTitle: 'View Party'
            },
            component: ViewParty
          }
        ],
        icon: AssignmentRoundedIcon,
        component: Parties
      },
      {
        path: '/trips',
        name: 'Trips',
        visible: true,
        type: 'submenu',
        state: {
          id: 1,
          pageTitle: 'Trips'
        },
        icon: PinDropIcon,
        component: Trips,
        children: [
          {
            path: '/create',
            name: 'Create',
            state: {
              id: 1,
              pageTitle: 'Create Trip'
            },
            component: AddTrip
          }, {
            path: '/view/:id',
            name: 'View',
            state: {
              id: 1,
              pageTitle: 'View Trip'
            },
            component: ViewJourney
          }, {
            path: '/sim-tracking-map/:id',
            name: 'Map',
            state: {
              id: 1,
              pageTitle: 'Map'
            },
            component: MapComponent
          }
        ]
      },
      {
        path: '/suppliers',
        visible: true,
        name: 'Suppliers',
        pageTitle: 'Suppliers',
        type: 'submenu',
        state: {
          id: 1,
          pageTitle: 'Suppliers'
        },
        children: [
          {
            path: '/single-supplier',
            name: 'Single Supplier',
            tabs: [
              {
                path: '/trips/:id',
                name: 'TripsSupplier',
                type: 'tab',
                component: TripsTabSupplier,
                state: {
                  id: 1,
                  tabTitle: 'Trips'
                }
              },
              {
                path: '/passbook/:id',
                name: 'PassbookSupplier',
                type: 'tab',
                component: PassBookTabSupplier,
                state: {
                  id: 1,
                  tabTitle: 'PassBook'
                }
              }
            ],
            state: {
              id: 1,
              pageTitle: 'View Supplier'
            },
            component: ViewSupplier
          }
        ],
        icon: AccountCircleRoundedIcon,
        component: Suppliers
      },
      {
        path: '/drivers',
        name: 'Drivers',
        visible: true,
        pageTitle: 'Drivers',
        type: 'submenu',
        state: {
          id: 1,
          pageTitle: 'Drivers'
        },
        icon: SteeringWheel,
        component: Drivers,
        children: [
          {
            path: '/single-driver/:id',
            name: 'singleDriver',
            state: {
              id: 1,
              pageTitle: 'Single Driver'
            },
            component: SingleDriver,
          }
        ]
      },
      {
        path: '/trucks',
        pageTitle: 'Trucks',
        visible: true,
        state: {
          id: 1,
          pageTitle: 'Trucks'
        },
        name: 'Trucks',
        type: 'submenu',
        icon: LocalShippingRoundedIcon,
        component: Vehicle,
        children: [
          {
            path: '/single-truck/:id',
            name: 'singleTruck',
            state: {
              id: 1,
              pageTitle: 'Single Truck'
            },
            component: SingleVehicle
          }
        ]
      },
      {
        path: '/expenses',
        pageTitle: 'Expenses',
        visible: true,
        state: {
          id: 1,
          pageTitle: 'Expenses'
        },
        badge: {
          value: "NEW",
          type: "newFeature"
        },
        name: 'Expenses',
        type: 'page',
        icon: ExpensesIconDweb,
        component: Expenses,
      },
      {
        path: '/diesel-card',
        pageTitle: 'Diesel Card',
        visible: fuelCardConfig && fuelCardConfig.show ? true : false,
        state: {
          id: 1,
          pageTitle: "Diesel Card"
        },
        type: "submenu",
        name: "Diesel Card",
        icon: DieselCardIcon,
        component: DieselCard,
        badge: {
          value: "NEW",
          type: "newFeature"
        },
        children: [
          {
            path: "/single-diesel-card/:vehicleId/:brokerId",
            name: "singleDieselCard",
            state: {
              id: 1,
              pageTitle: 'Single Diesel Card'
            },
            component: SingleDieselCard
          }
        ]
      },
      {
        path: '/fastag',
        pageTitle: 'FASTag',
        visible: true,
        state: {
          id: 1,
          pageTitle: 'FASTag Recharge'
        },
        name: 'FASTag',
        type: 'submenu',
        icon: FastagIconDweb,
        component: Fastag,
        children: [
          {
            path: '/single-truck/:id',
            name: 'fastagSingleTruck',
            state: {
              id: 1,
              pageTitle: 'FASTag Truck'
            },
            component: ViewFastagTruck
          }
        ]
      },
      {
        path: '/shops',
        pageTitle: 'Shop Khata',
        visible: true,
        state: {
          id: 1,
          pageTitle: 'Shop Khata'
        },
        name: 'Shop Khata',
        type: 'submenu',
        icon: ShopKhataIcon,
        component: Shops,
        /*badge: {
          value: "NEW",
          type: "newFeature"
        },*/
        children: [
          {
            path: '/shop/:id',
            name: 'Shop',
            state: {
              id: 1,
              pageTitle: 'Shop'
            },
            component: ViewShop
          }
        ]
      },
      {
        path: '/invoices',
        pageTitle: 'Invoices',
        visible: true,
        state: {
          id: 1,
          pageTitle: 'Invoices'
        },
        name: 'Invoices',
        type: 'submenu',
        icon: InvoicesIcon,
        component: Invoice,
        /*badge: {
          value: "NEW",
          type: "newFeature"
        },*/
        children: [
          {
            path: '/single-invoice/:id',
            name: 'singleInvoice',
            state: {
              id: 1,
              pageTitle: 'Single Invoice'
            },
            component: SingleInvoice
          }
        ]
      },
      {
        path: '/online-payments',
        pageTitle: 'Online Payments',
        visible: onlinePaymentConfig && onlinePaymentConfig.showWidget ? true : false,
        state: {
          id: 1,
          pageTitle: 'Online Payments'
        },
        name: 'Online Payments',
        type: 'page',
        icon: OnlinePaymentIcon,
        component: OnlinePayments,
      },
      {
        path: '/reports',
        pageTitle: 'Reports',
        visible: true,
        state: {
          id: 1,
          pageTitle: 'Reports'
        },
        name: 'Reports',
        type: 'page',
        icon: ReportsIconDweb,
        component: Reports,
      },
      // {
      //   path: '/transaction',
      //   name: 'Transactions',
      //   pageTitle: 'Transactions',
      //   state: {
      //     id: 1,
      //     pageTitle: 'Transactions'
      //   },
      //   type: 'link',
      //   icon: AccountsMenu,
      //   component: Parties
      // },
      // {
      //   path: '/account',
      //   name: 'Accounts',
      //   state: {
      //     id: 1,
      //     pageTitle: 'Accounts'
      //   },
      //   type: 'link',
      //   icon: TransactionMenu,
      //   component: Parties
      // } ,
    ]
  };
  if (role != "USER") {
    routes.items.push({
      path: '/profile',
      name: 'Profile',
      visible: true,
      state: {
        id: 1,
        pageTitle: 'Profile'
      },
      type: 'submenu',
      icon: TransactionMenu,
      component: Profile,
      children: [
        {
          path: '/account',
          name: 'account',
          state: {
            id: 1,
            pageTitle: 'Account'
          },
          component: Account,
        },
        {
          path: '/user-management',
          name: 'userManagement',
          state: {
            id: 1,
            pageTitle: 'UserManagment'
          },
          component: UserManagement
        }
      ]
    })

    routes.items.push({
      path: '/payments',
      name: 'Premium',
      visible: true,
      type: 'submenu',
      id: "premium",
      pageTitle: 'Premium',
      state: {
        id: 1,
        pageTitle: 'Premium'
      },
      icon: PremiumMenuIcon,
      className: "premium-menu",
      component: PaymentPageNew,
      headerIcon:true,
      children: [
        {
          path: '/order_status/:id',
          name: 'Premium',
          id: "premium",
          state: {
            id: 1,
            pageTitle: 'Payment Status'
          },
          component: PaymentPageNew,
        }
      ]
    })
  }
  /*let premEnabled = configs && configs.subscription && configs.subscription.enabled && configs.subscription.enabled ==1?true:false;
  if (premEnabled) {
    routes.items.push({
      path: '/payments',
      name: 'Premium',
      visible: true,
      type: 'submenu',
      id: "premium",
      pageTitle: 'Premium',
      state: {
        id: 1,
        pageTitle: 'Premium'
      },
      icon: PremiumMenuIcon,
      className: "premium-menu",
      component: Payments,
      children: [
        {
          path: '/order_status/:id',
          name: 'Premium',
          id:"premium",
          state: {
            id: 1,
            pageTitle: 'Payment Status'
          },
          component: Payments,
        }
      ]
    })
  }*/
  return routes
}

// const webRoutes = getRoutes();
// export default webRoutes;